import React from 'react';
import PropTypes from 'prop-types';

import { SectionOuterWrapper, SectionInnerWrapper } from './Section.atoms';
import { COLORS } from '../../../assets/styles/constants';

const mappedColors = {
	white: COLORS.WHITE,
	gray: COLORS.GRAY_LIGHTEST,
	blue: COLORS.BLUE_LIGHT,
	darkBlue: COLORS.DARK_BLUE,
};

const Section = (props) => {
	const {
		children,
		background,
		padding,
		margin,
		scale,
	} = props;

	const color = mappedColors[background] || mappedColors.white;

	return (
		<SectionOuterWrapper
			color={color}
		>
			<SectionInnerWrapper
				padding={padding}
				margin={margin}
				scale={scale ? 1 : 0}
			>
				{children}
			</SectionInnerWrapper>
		</SectionOuterWrapper>
	);
};

Section.defaultProps = {
	background: 'white',
	scale: false,
	padding: null,
	margin: null,
	children: null,
};

Section.propTypes = {
	children: PropTypes.node,
	background: PropTypes.oneOf(['white', 'gray', 'blue', 'darkBlue']),
	scale: PropTypes.bool,
	padding: PropTypes.string,
	margin: PropTypes.string,
};

export default Section;
